/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';

import style from '../../../../../assets/styles/testCreationStyle.module.css';
import { CallWithAuth } from '../../../../../action/apiActions';
import { CREATE_TESTS_BASIC_SETTING, GET_FREE_TAG, GET_PRODUCT, GET_TASKS_LABEL } from '../../../../../action/apiPath';
import { useDispatch, useSelector } from 'react-redux';
import { Add_Basic_Setting_Test, Edit_Test, Get_All_Category, Get_Product_Type } from '../../../../../redux/action';
// * import { change_test_screen} from '../../../../../redux/action';
import QuillEditor from '../../../../atoms/QuillEditor';
import TextInputs from './InputField';
import ChipsSearchBar from './ChipsSearchBar';
import {
  CREATE_TEST_BASIC_SETTING_SUCCESS,
  CREATE_TEST_BASIC_SETTING_SUCCESS_VIA_API,
} from '../../../../../redux/constant';
import { useToast } from '../../../common/Toast';
import { useNavigate, useLocation } from 'react-router-dom';
import NativeButton from '../../../../atoms/Button';

import Loader from '../../../../loader';

const BasicSettings = ({ MasterData, isEdit, setSelectedType, onAdd, isView, getData }) => {
  const [isInitialized, setIsInitialized] = useState(false);
  const [isLoading, setIsLoading] = useState(isEdit || isView);
  const rowRef = useRef();
  const location = useLocation();
  const testAuthoringTaskId = location.state?.testAuthoringTaskId;
  const dispatch = useDispatch();
  const { categoryList, getProductType, testDetails, getBasicSettingData, testCreationId } = useSelector(
    (state) => state.GetAllData
  );
  const organizationId = localStorage.getItem('selectedOrgId');
  const [taskLabel, setTaskLabel] = useState(null);
  const [templateList, setTemplateList] = useState([]);
  const templateId = 0;
  useEffect(() => {
    !categoryList && dispatch(Get_All_Category(organizationId));
    getTemplate(templateId);
    if (testAuthoringTaskId) {
      setTaskLabel(testAuthoringTaskId);
    } else if (testDetails?.task_label) {
      setTaskLabel(testDetails?.task_label);
    } else if (getBasicSettingData?.task_label) {
      setTaskLabel(getBasicSettingData?.task_label);
    }
  }, []);
  const getTemplate = async (id) => {
    const data = await CallWithAuth('GET', GET_PRODUCT + '?test_type=' + id);
    if (data.status && data.res.status === 200) {
      setTemplateList(data.res.data);
    }
  };

  //_______________________________________________ Creation of new test _________________________
  const [testName, setTestName] = useState('');
  const [noofQuestiontoPass, setNoofQuestiontoPass] = useState(null);
  const [rendering_template, setRendering_template] = useState(null);
  const [academicYear, setAcademicYear] = useState(null);
  const [category, setCategory] = useState(null);
  const [multiselectedfreeTag, setMultiselectedfreeTag] = useState([]);
  const [newFreeTag, setNewFreeTag] = useState([]);
  const [markingScheme, setMarkingScheme] = useState(0);
  const [correctAnswerMarks, setCorrectAnswerMarks] = useState(null);
  const [incorrectAnswerMarks, setIncorrectAnswerMarks] = useState(null);
  const [unattemptedPenalty, setUnattemptedPenalty] = useState(null);
  const [unattempted_penalty_starts_from, setUnattempted_penalty_starts_from] = useState(null);
  const [randomizeGroups, setRandomizeGroups] = useState(false);
  const [taskLabelInput, setTaskLabelInput] = useState('');
  const [taskLabelInputStatus, setTaskLabelInputStatus] = useState(false);
  const [taskLabelTag, setTaskLabelTag] = useState([]);
  const [enableOmr, setEnableOmr] = useState(false);
  const [instruction, setInstruction] = useState([
    {
      has_timer: false,
      minutes: null,
      seconds: null,
      instruction_text: '',
    },
  ]);
  const [testType, setTestType] = useState(
    testDetails?.test_type
      ? testDetails?.test_type
      : getBasicSettingData?.test_type
        ? getBasicSettingData?.test_type
        : 0
  );
  const navigate = useNavigate();

  let body = {
    org_id: organizationId,
    test_type: testType,
    rendering_template: rendering_template,
    test_name: testName,
    academic_year: academicYear,
    category: category,
    free_tags: multiselectedfreeTag,
    new_free_tags: newFreeTag,
    number_of_questions_to_pass: noofQuestiontoPass,
    task_label: taskLabel ? Number(taskLabel) : null,
    marking_scheme: markingScheme,
    correct_answer_marks: correctAnswerMarks,
    incorrect_answer_marks: incorrectAnswerMarks,
    unattempted_penalty: unattemptedPenalty,
    unattempted_penalty_starts_from: unattempted_penalty_starts_from,
    marking_logic_level: 0,
    instructions: instruction,
    randomize_groups: randomizeGroups,
    config: { enable_omr: enableOmr },
  };

  //_______________ Fn for handle test type
  const handleRenderingTemplate = (e) => {
    const selectedTemplate = Number(e.target.value);
    setRendering_template(selectedTemplate);
  };
  const handleRemoveTaskLabel = () => {
    setTaskLabel(null);
  };
  const taskLabelLists = async (e) => {
    setTaskLabelInput(e);
    if (e.length > 0) {
      const data = await CallWithAuth(
        'GET',
        `${GET_TASKS_LABEL}${organizationId}/?task_type=2&task_id=${e}&question_bank_id=`
      );
      if (data?.status && data?.res?.status === 200) {
        if (data.res.data.length > 0) {
          setTaskLabelTag(data.res.data);
          setTaskLabelInputStatus(true);
        } else {
          setTaskLabelInputStatus(false);
        }
      }
    } else {
      setTaskLabelInputStatus(false);
    }
  };
  const selectTaskLabelTag = (e) => {
    setTaskLabelInputStatus(false);
    setTaskLabel(e.id);
    setTaskLabelInput('');
  };
  const handleTestType = (e) => {
    const selectedTemplate = Number(e.target.value);
    setTestType(selectedTemplate);
    setSelectedType(selectedTemplate);
  };

  //_______________ Fn for handle test name
  const handleTestName = (e) => {
    const selectedName = e.target.value;
    setTestName(selectedName);
  };
  const updateStates = (data) => {
    setTestType(data?.test_type);
    setSelectedType(data?.test_type);
    setTestName(data?.test_name);
    setNoofQuestiontoPass(data?.number_of_questions_to_pass);
    setRendering_template(data?.rendering_template);
    setAcademicYear(data?.academic_year);
    setCategory(data?.category);
    setMultiselectedfreeTag(data?.free_tags?.map((tag) => ({ id: tag.id, name: tag.name })));
    setMarkingScheme(data?.marking_scheme);
    setCorrectAnswerMarks(data?.correct_answer_marks);
    setIncorrectAnswerMarks(data?.incorrect_answer_marks);
    setUnattemptedPenalty(data?.unattempted_penalty);
    setUnattempted_penalty_starts_from(data?.unattempted_penalty_starts_from);
    setRandomizeGroups(data?.randomize_groups);
    setTaskLabel(data?.task_label);
    setEnableOmr(data?.config?.enable_omr ?? false);
    data?.instructions[0] &&
      setInstruction(
        data?.instructions?.map((instruction, index) => {
          return {
            instruction_id: instruction?.instruction_id ?? index,
            has_timer: instruction?.has_timer,
            minutes: instruction.minutes || 0,
            seconds: instruction.seconds || 0,
            instruction_text: instruction.instruction_text || '',
          };
        })
      );
  };
  useEffect(() => {
    if (isInitialized) return;
    if (testDetails && !onAdd) {
      updateStates(testDetails);
      setIsInitialized(true);
      setIsLoading(false);
    } else if (onAdd) {
      if (getBasicSettingData) {
        updateStates(getBasicSettingData);
        const chips = getBasicSettingData?.free_tags.map((item) => item.name);
        setChipsData([...chips, ...getBasicSettingData?.new_free_tags]);
      }
      setIsInitialized(true);
      setIsLoading(false);
    }
  }, [testDetails, getBasicSettingData, isInitialized, onAdd]);
  const handleNumberOfQuestionToPass = (e) => {
    if (e.target.value > 0) {
      const selectedNumber = Number(e.target.value);
      setNoofQuestiontoPass(selectedNumber);
    } else {
      setNoofQuestiontoPass(null);
    }
  };

  //_______________ Fn for handle academic year
  const handleAcademicYear = (e) => {
    const selectedYear = Number(e.target.value);
    setAcademicYear(selectedYear);
  };

  //_______________ Fn for handle category
  const handleCategory = (e) => {
    const selectedCategory = Number(e.target.value);
    setCategory(selectedCategory);
  };

  //_______________ Fn for handle free tags

  // ________________ Initialization of FREE TAG ________________//
  const [multifreeTaginput, setMultifreeTaginput] = useState('');
  const [multifreeTag, setMultifreeTag] = useState([]);
  const [multifreeTagStatus, setMultifreeTagStatus] = useState(false);
  const [newfreeTags, setNewfreeTags] = useState([]);
  const [newfreeTagStatus, setNewfreeTagStatus] = useState(false);
  const [chipsData, setChipsData] = useState([]);
  // CALL GET API FOR getting TAGS
  const TagFreeMultiple = async (e) => {
    setMultifreeTaginput(e);
    if (e.length > 2) {
      const data = await CallWithAuth('GET', GET_FREE_TAG + '?keyword=' + e);
      if (data.status && data.res.status === 200) {
        if (data.res.data.length > 0) {
          setMultifreeTag(data.res.data);
          setNewfreeTagStatus(false);
          setMultifreeTagStatus(true);
        } else {
          setNewfreeTags([e]);
          setMultifreeTagStatus(false);
          setNewfreeTagStatus(true);
        }
      }
    } else {
      setMultifreeTagStatus(false);
    }
  };
  function removeDuplicates(arr) {
    return Array.from(new Map(arr.map((item) => [item.id, item])).values());
  }
  // select tags from options
  const selectFreeTag = (e) => {
    const newData = removeDuplicates([...multiselectedfreeTag, e]);
    setMultiselectedfreeTag(newData);
    setMultifreeTagStatus(false);
    setMultifreeTaginput('');
  };

  const selectnewFreeTag = (e) => {
    const newData = [...newFreeTag, e];
    setNewFreeTag([...new Set(newData)]);
    setNewfreeTagStatus(false);
    setMultifreeTaginput('');
  };

  const CancelButton = (e) => {
    e.preventDefault();
    setNewFreeTag([]);
    setMultiselectedfreeTag([]);
  };
  //_______________ Fn for handle free tags over }

  //_______________ Fn for handle marking schemes
  const handleMarkingScheme = (e) => {
    const selectedMarking = Number(e.target.value);
    setMarkingScheme(selectedMarking);
  };

  //_______________ Fn for handle input markings
  const handleInputChange = (e, setter) => {
    const value = e.target.value;
    setter(value === '' ? value : Number(value));
  };

  //________________Fn for handle Intructions

  const handleTimerChange = (event, type, index) => {
    let value;
    if (type === 'has_timer') {
      value = event.target.checked;
    } else {
      value = parseInt(event.target.value, 10);
    }
    const newState = structuredClone(instruction);
    newState[index][type] = value;
    setInstruction(newState);
  };

  const handleInstructionTextChange = (content, index, event) => {
    const answer = btoa(unescape(encodeURIComponent(content)));

    setInstruction((prevState) => {
      const newState = [...structuredClone(prevState)];
      newState[index].instruction_text = answer;
      return newState;
    });
  };

  const addScreen = () => {
    setInstruction((prevState) => [
      ...prevState,
      {
        has_timer: false,
        minutes: null,
        seconds: null,
        instruction_text: '',
      },
    ]);
  };

  const removeScreen = (index) => {
    setInstruction((prevState) => prevState.filter((_, i) => i !== index));
  };

  //_______________________________________ Instructions exit ________________________________//

  const generateYears = () => {
    const currentYear = new Date().getFullYear();
    const startYear = 2011;
    const endYear = currentYear + 5;
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push(year);
    }
    return years;
  };

  const decodeBase64 = (base64String) => {
    return b64DecodeUnicode(base64String);
  };

  function b64DecodeUnicode(str) {
    return decodeURIComponent(
      atob(str)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
  }
  const testTypeArray = [
    { id: 0, name: 'Static' },
    { id: 1, name: ' Quasi-Adaptive' },
    { id: 2, name: 'LOFT' },
  ];
  useEffect(() => {
    const chips = multiselectedfreeTag.map((item) => item.name);
    setChipsData([...chips, ...newFreeTag]);
  }, [multiselectedfreeTag, newFreeTag]);
  const onChipsChange = (tag) => {
    const newMultiselectedfreeTag = multiselectedfreeTag?.filter((item) => item.name !== tag);
    setMultiselectedfreeTag(newMultiselectedfreeTag);
    const freeTag = newFreeTag?.filter((item) => item !== tag);
    setNewFreeTag(freeTag);
  };
  const getTesttypeStyle = () => {
    return {
      // eslint-disable-next-line eqeqeq
      color: testType || testType == 0 ? 'black' : '#808080',
    };
  };
  const getAcademicyearStyle = () => {
    return {
      color: academicYear ? 'black' : '#808080',
    };
  };
  const getCategoryStyle = () => {
    return {
      color: category ? 'black' : '#808080',
    };
  };
  const getTestPaperStyle = () => {
    return {
      color: rendering_template || rendering_template == 0 ? 'black' : '#808080',
    };
  };
  const toast = useToast();
  const handleSaveAndContinue = async () => {
    const body = {
      org_id: organizationId,
      test_type: testType,
      rendering_template: rendering_template,
      test_name: testName,
      academic_year: academicYear,
      category: category,
      free_tags: multiselectedfreeTag?.map((item) => item.id),
      new_free_tags: newFreeTag,
      correct_answer_marks: correctAnswerMarks,
      incorrect_answer_marks: incorrectAnswerMarks,
      unattempted_penalty: unattemptedPenalty,
      unattempted_penalty_starts_from: unattempted_penalty_starts_from,
      task_label: taskLabel ? Number(taskLabel) : null,
      instructions: instruction,
      randomize_groups: randomizeGroups,
      number_of_questions_to_pass: noofQuestiontoPass,
      config: { enable_omr: enableOmr },
    };
    if (isEdit) {
      body.id = testDetails?.id;
    }
    if (onAdd && getBasicSettingData?.id) {
      body.id = getBasicSettingData?.id;
    }
    const url = isEdit
      ? `${CREATE_TESTS_BASIC_SETTING}${testDetails?.id}/update/`
      : onAdd && getBasicSettingData?.id
        ? `${CREATE_TESTS_BASIC_SETTING}${getBasicSettingData?.id}/update/`
        : CREATE_TESTS_BASIC_SETTING;
    const data = await CallWithAuth(isEdit || (onAdd && getBasicSettingData?.id) ? 'PATCH' : 'POST', url, body);
    if (data.status && (data.res.status === 201 || data.res.status === 200)) {
      toast?.add(data.res.data.message, 'success');
      const response = data?.res?.data?.data;
      const screen = 1;
      body.free_tags = multiselectedfreeTag;
      getData(testDetails?.id ?? getBasicSettingData?.id);
      dispatch({ type: CREATE_TEST_BASIC_SETTING_SUCCESS_VIA_API, response, screen, body });
    } else {
      toast?.add(data.res.data.error, 'error');
      console.log('error', data);
    }
  };

  const refreshTestDetails = () => {
    getData(testDetails?.id ?? testCreationId);
  };
  if (isLoading) {
    return <Loader />;
  }
  return (
    (((isEdit || isView) && (testDetails || getBasicSettingData)) || onAdd) && (
      <div className={style.masterTestCreation}>
        <div className={`${style.testCreationArea} ${isView ? style.isViewMainContainer : ''}`}>
          <div className={style.bound}>
            <div className={style.templateDrop}>
              <div className={style.templateDrop_item}>
                <div className={style.templateGroup}>
                  <span>Test Type </span>
                  <b className={style.red_mendantory}>*</b>
                  <select
                    tabIndex={0}
                    value={testType}
                    name="question"
                    id="question"
                    style={getTesttypeStyle()}
                    className={`${style.template_drop_filter} select-focused`}
                    onChange={handleTestType}
                    disabled={isEdit || testDetails?.test_type || getBasicSettingData}
                  >
                    {testTypeArray?.map((items, i) => (
                      <option key={i + items.name} value={items.id}>
                        {items.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className={style.templateDrop}>
              <div className={style.templateDrop_item}>
                <div className={style.templateGroup}>
                  <span>Test Paper Rendering Template </span>
                  <b className={style.red_mendantory}>*</b>
                  <select
                    tabIndex={0}
                    value={rendering_template}
                    disabled={isEdit && !testDetails?.remove_sections}
                    name="question"
                    id="question"
                    style={getTestPaperStyle()}
                    className={`${style.template_drop_filter} select-focused`}
                    onChange={handleRenderingTemplate}
                  >
                    {/* <option hidden>{rendering_template}</option> */}
                    <option>Select Rendering Template</option>
                    {templateList?.map((items, i) => (
                      <option key={i + items.product_type} value={items.id}>
                        {items.product_type}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className={style.bound}>
            <TextInputs
              tabIndex={0}
              placeholder={'Enter Test Name'}
              onChange={handleTestName}
              style={style}
              label="Test Names"
              inputType="text"
              value={testName}
            />

            <div className={style.templateDrop}>
              <div className={style.templateDrop_item}>
                <div className={style.templateGroup}>
                  <span>Academic Year </span>
                  <b className={style.red_mendantory}>*</b>
                  <select
                    tabIndex={0}
                    name="question"
                    value={academicYear}
                    id="question"
                    className={`${style.template_drop_filter} select-focused`}
                    style={getAcademicyearStyle()}
                    onChange={handleAcademicYear}
                  >
                    <option>Select Academic Year</option>
                    {generateYears().map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className={style.templateDrop} style={{ marginBottom: '10px' }}>
            <div style={{ display: 'flex', gap: '25px' }} className={style.templateDrop_item}>
              <div className={style.templateGroup}>
                <span>Category </span>
                <b className={style.red_mendantory}>*</b>
                <select
                  tabIndex={0}
                  value={category}
                  name="question"
                  id="question"
                  className={`${style.template_drop_filter} select-focused`}
                  style={getCategoryStyle()}
                  onChange={handleCategory}
                >
                  <option value={null}>Select Category</option>
                  {Array.isArray(categoryList) &&
                    categoryList.map((items, i) => (
                      <option key={i + items?.name} value={items?.id}>
                        {items?.name}
                      </option>
                    ))}
                </select>
              </div>
              <div className={style.templateGroup}>
                <span>Number of Question to Pass </span>

                <input
                  type="number"
                  min="0"
                  step="1"
                  value={noofQuestiontoPass}
                  onChange={handleNumberOfQuestionToPass}
                  placeholder=""
                  className={style.template_drop_filter}
                  autoComplete="off"
                  onKeyDown={(e) => {
                    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                      e.preventDefault();
                    }
                  }}
                  onWheel={(e) => e.target.blur()}
                />
              </div>
            </div>
          </div>
          <div className={style.toggleGroups}>
            <span className={style.btnLabel}>Enable OMR</span>
            <div className={`${style.toggleButtons}`}>
              <button
                type="button"
                className={!enableOmr ? `${style.active}` : `${style.notActive}`}
                onClick={() => setEnableOmr(false)}
              >
                No
              </button>
              <button
                type="button"
                className={enableOmr ? `${style.active}` : `${style.notActive}`}
                onClick={() => setEnableOmr(true)}
              >
                Yes
              </button>
            </div>
          </div>

          <div className={style.templateDrop}>
            <div className={style.templateDrop_item}>
              <div className={style.templateGroup}>
                <ChipsSearchBar
                  onChipsChange={onChipsChange}
                  chipsTags={chipsData}
                  onNewChange={selectnewFreeTag}
                  onExistingChange={selectFreeTag}
                  newData={newfreeTags}
                  newDataStatus={newfreeTagStatus}
                  existingDataStatus={multifreeTagStatus}
                  existingData={[...multifreeTag]}
                  placeholder={'Search for tags'}
                  label="Free Form Tags"
                  searchTagLabel="Tags"
                  value={multifreeTaginput}
                  onInputChange={TagFreeMultiple}
                  testType={testType}
                />
              </div>
            </div>
          </div>
          <div className={style.templateDrop}>
            <div className={style.templateDrop_item}>
              <div className={style.templateGroup} style={{ width: '52%' }}>
                <p>Add Task Label - Choose from Assigned Tasks </p>
                <div className={style.input_search}>
                  <div className={`${style.search_listing} ${style.search_listing_tasklabel}`}>
                    <div className={style.tag_icon_tasklabel}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M11.5 18C15.0899 18 18 15.0899 18 11.5C18 7.91015 15.0899 5 11.5 5C7.91015 5 5 7.91015 5 11.5C5 15.0899 7.91015 18 11.5 18Z"
                          stroke="#212529"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M18.2598 19.2592L16.1406 16.8594"
                          stroke="#212529"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <span>Label</span>
                    </div>
                    {taskLabel ? (
                      <>
                        <div className={`${style.input_search} ${style.input_search_tasklabel}`}>
                          <div style={{ fontWeight: 'normal' }}>{taskLabel}</div>
                        </div>
                        {!testAuthoringTaskId && !testDetails?.task_label && (
                          <div className={`${style.cancel_button} ${style.cancel_button_assignee}`}>
                            <button className={style.pointer} onClick={handleRemoveTaskLabel}>
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.75781 7.75781L16.2431 16.2431"
                                  stroke="#272727"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M7.75691 16.2431L16.2422 7.75781"
                                  stroke="#272727"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </button>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className={`${style.input_search}`}>
                        <input
                          className={`${style.input_search} ${style.paddingInput} ${style.input_search_tasklabel}`}
                          type="number"
                          id="searchInput"
                          placeholder="Choose task label"
                          value={taskLabelInput}
                          onChange={(e) => taskLabelLists(e.target.value)}
                          autoComplete="off"
                          onKeyDown={(e) => {
                            if (
                              e.key === 'ArrowUp' ||
                              e.key === 'ArrowDown' ||
                              e.key === 'e' ||
                              e.key === 'E' ||
                              e.key === '+' ||
                              e.key === '-' ||
                              e.key === '.'
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onWheel={(e) => e.target.blur()}
                        />
                        {taskLabelInputStatus ? (
                          <div className={style.list_input_primary} style={{ width: '95%' }}>
                            {taskLabelTag?.map((items, i) => (
                              <NativeButton key={items.id + i} onClick={() => selectTaskLabelTag(items)}>
                                <div className={style.pointer}>
                                  <span>{items.id} </span>
                                </div>
                              </NativeButton>
                            ))}
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* //-------------------Basic Static Start-------------------------// */}
          {testType === 0 && (
            <div className={style.templateDrop}>
              <hr className={style.hrLine} />
              <div className={style.pageTwoContainer}>
                <h3 className={style.testMarklabel}>Test Marking Details</h3>
                <div className={style.templateDrop}>
                  <div className={style.templateDrop_item}>
                    <div className={style.templateGroup}>
                      <span>Marking Scheme </span>
                      <b className={style.red_mendantory}>*</b>
                      <select
                        name="question"
                        id="question"
                        className={style.template_drop_filter}
                        onClick={handleMarkingScheme}
                      >
                        <option value={0}>Regular -Per Question</option>
                        {/* <option value={1}>Progressive - Across Section</option>
                                      <option value={2}>Progressive - Section-wise</option> */}
                      </select>
                    </div>
                  </div>
                </div>
                <p style={{ paddingTop: '10px', paddingBottom: '10px' }} className={style.info}>
                  All questions will follow this marking logic. Marking logic can be overwritten at a question level on
                  next screen.
                </p>
                <div className={style.bound}>
                  <div className={style.templateDrop}>
                    <div className={style.templateDrop_item}>
                      <div className={style.templateGroup}>
                        <span>Correct Answer Marks </span>
                        <b className={style.red_mendantory}>*</b>
                        <input
                          type="number"
                          name="question"
                          id="question"
                          className={style.score_drop_filter}
                          placeholder="Input +/- score"
                          value={correctAnswerMarks}
                          onChange={(e) => handleInputChange(e, setCorrectAnswerMarks)}
                          autoComplete="off"
                          onKeyDown={(e) => {
                            if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                              e.preventDefault();
                            }
                          }}
                          onWheel={(e) => e.target.blur()}
                        />
                      </div>
                    </div>
                  </div>

                  <div className={style.templateDrop}>
                    <div className={style.templateDrop_item}>
                      <div className={style.templateGroup}>
                        <span>Incorrect Answer Marks </span>
                        <b className={style.red_mendantory}>*</b>
                        <input
                          type="number"
                          name="question"
                          id="question"
                          className={style.score_drop_filter}
                          placeholder="Input +/- score"
                          value={incorrectAnswerMarks}
                          onChange={(e) => handleInputChange(e, setIncorrectAnswerMarks)}
                          autoComplete="off"
                          onKeyDown={(e) => {
                            if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                              e.preventDefault();
                            }
                          }}
                          onWheel={(e) => e.target.blur()}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Test type */}

                  <div className={style.templateDrop}>
                    <div className={style.templateDrop_item}>
                      <div className={style.templateGroup}>
                        <span>Unattempted Penalty </span>
                        <input
                          type="number"
                          name="question"
                          id="question"
                          className={style.score_drop_filter}
                          placeholder="Input +/- score"
                          value={unattemptedPenalty}
                          onChange={(e) => {
                            const value = e.target.value;
                            setUnattemptedPenalty(value === '' ? null : Number(value));
                          }}
                          autoComplete="off"
                          onKeyDown={(e) => {
                            if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                              e.preventDefault();
                            }
                          }}
                          onWheel={(e) => e.target.blur()}
                        />
                      </div>
                    </div>
                  </div>

                  <div className={style.templateDrop}>
                    <div className={style.templateDrop_item}>
                      <div className={style.templateGroup}>
                        <span>Unattempted Penalty Start From </span>
                        <input
                          type="number"
                          name="question"
                          id="question"
                          className={style.score_drop_filter}
                          placeholder="Input +/- score"
                          value={unattempted_penalty_starts_from}
                          autoComplete="off"
                          onKeyDown={(e) => {
                            if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                              e.preventDefault();
                            }
                          }}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) => {
                            const value = e.target.value;
                            setUnattempted_penalty_starts_from(value === '' ? null : Number(value));
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <hr className={style.hrLine} />
                <h3 className={style.testMarklabel}>Test Instructions</h3>
                <p className={style.info}>Add instructions to appear before the test commences</p>
                {instruction?.map((instruction, index) => (
                  <div key={index + instruction} className={style.screenNum}>
                    <p style={{ fontWeight: 500 }}>Screen {index + 1}</p>
                    <div className={style.icon_text}>
                      <label className="custom-checkbox" aria-label="Has Timer">
                        <input
                          type="checkbox"
                          checked={Boolean(instruction.has_timer)}
                          onChange={(e) => handleTimerChange(e, 'has_timer', index)}
                        />
                        <span className="checkmark"></span>
                      </label>
                      {/* <label>Has Timer</label> */}

                      <p className={style.info}>Instruction Screen has a timer</p>
                    </div>

                    {Boolean(instruction.has_timer) && (
                      <div className={style.timer}>
                        <input
                          className={style.timer_input}
                          type="number"
                          name="minutes"
                          min="0"
                          max="100"
                          step="1"
                          autoComplete="off"
                          list="autocompleteoff"
                          value={instruction.minutes}
                          onChange={(e) => handleTimerChange(e, 'minutes', index)}
                        />
                        <label htmlFor="minutes">Minutes</label>

                        <input
                          className={style.timer_input}
                          type="number"
                          name="seconds"
                          min="0"
                          max="100"
                          step="1"
                          autoComplete="off"
                          list="autocompleteoff"
                          value={instruction.seconds}
                          onChange={(e) => handleTimerChange(e, 'seconds', index)}
                        />
                        <label htmlFor="seconds">Seconds</label>
                      </div>
                    )}
                    <p className={style.marketLogic}>Test Instructions </p>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '2rem',
                      }}
                    >
                      <div style={{ height: 'auto', flexGrow: '1' }}>
                        <QuillEditor
                          defaultValue={decodeBase64(instruction.instruction_text)}
                          onChange={(content) => handleInstructionTextChange(content, index)}
                          disabled={isView}
                        />
                      </div>
                      {!isView && (
                        <div>
                          {index !== 0 && (
                            <button type="button" className={style.penaltyDelete} onClick={() => removeScreen(index)}>
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M18.8504 9.14062L18.2004 19.2106C18.0904 20.7806 18.0004 22.0006 15.2104 22.0006H8.79039C6.00039 22.0006 5.91039 20.7806 5.80039 19.2106L5.15039 9.14062"
                                  stroke="#272727"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047"
                                  stroke="#272727"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
                                  stroke="#272727"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
                {!isView && (
                  <div onClick={() => addScreen()} className={style.threshold}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                        stroke="#00ABFB"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M7.5 12H16.5"
                        stroke="#00ABFB"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M12 16.5V7.5"
                        stroke="#00ABFB"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <h5>Add Screen</h5>
                  </div>
                )}
                <div className={style.icon_text} style={{ marginBottom: '20px' }}>
                  <label className="custom-checkbox" aria-label="Has Timer">
                    <input
                      type="checkbox"
                      checked={randomizeGroups}
                      onChange={() => setRandomizeGroups(!randomizeGroups)}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <p className={style.info}>Randomize Groups</p>
                </div>
                {!isView && (
                  <div className={style.performBT}>
                    <button
                      className={` ${style.btOne} ${style.common}`}
                      onClick={() => {
                        navigate(`/test-papers-management`);
                      }}
                    >
                      Back
                    </button>
                    <button
                      className={` ${style.btTwo} ${style.common}`}
                      onClick={() => {
                        isEdit
                          ? dispatch(Edit_Test(testDetails?.id, body, toast, refreshTestDetails))
                          : onAdd && testDetails?.id
                            ? dispatch(Edit_Test(testDetails?.id, body, toast, refreshTestDetails))
                            : dispatch(Add_Basic_Setting_Test(body, toast, refreshTestDetails));

                        // isEdit
                        // ? `${CREATE_TESTS_BASIC_SETTING}${testDetails?.id}/update/`

                        //   ? `${CREATE_TESTS_BASIC_SETTING}${getBasicSettingData?.id}/update/`
                        //   : CREATE_TESTS_BASIC_SETTING;

                        getData(testDetails?.id ?? testCreationId);
                      }}
                    >
                      Save & Continue
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
          {/* //-------------------Basic Static End-------------------------// */}
          {testType == 1 && (
            <div className={style.templateDrop}>
              <hr className={style.hrLine} style={{ marginTop: '0.4em', marginBottom: '2.2em' }} />
              <div className={style.pageTwoContainer}>
                <h3 className={`${style.testMarklabel} ${style.mainHeadings}`}>Test Marking Details</h3>
                <p style={{ paddingTop: '10px', paddingBottom: '30px', margin: '0px' }} className={style.info}>
                  All questions will follow same marking logic unless new marking logics are created
                </p>
                <div className={style.templateDrop}>
                  <div style={{ display: 'flex', gap: '25px' }} className={style.templateDrop_item}>
                    <div className={style.templateGroup}>
                      <span>Unattempted Marks </span>
                      <b className={style.red_mendantory}>*</b>
                      <input
                        type="number"
                        name="question"
                        id="question"
                        className={style.score_drop_filter}
                        placeholder="Input +/- score"
                        value={unattemptedPenalty}
                        onChange={(e) => {
                          const value = e.target.value;
                          setUnattemptedPenalty(value === '' ? null : Number(value));
                        }}
                        onBlur={(e) => setUnattemptedPenalty(Number(e.target.value))}
                        onKeyDown={(e) => {
                          if (['e', 'E'].includes(e.key)) {
                            e.preventDefault();
                          }
                          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                            e.preventDefault();
                          }
                        }}
                        autoComplete="off"
                        list="autocompleteoff"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>

                    <div className={style.templateGroup}>
                      <span>Unattempted Penalty Start From </span>
                      {/* <b className={style.red_mendantory}>*</b> */}
                      <input
                        type="number"
                        name="question"
                        id="question"
                        className={style.score_drop_filter}
                        placeholder="Input +/- score"
                        value={unattempted_penalty_starts_from}
                        autoComplete="off"
                        onChange={(e) => {
                          const value = e.target.value;
                          setUnattempted_penalty_starts_from(value === '' ? null : Number(value));
                        }}
                        onKeyDown={(e) => {
                          if (['e', 'E'].includes(e.key)) {
                            e.preventDefault();
                          }
                          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                            e.preventDefault();
                          }
                        }}
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </div>
                </div>
                <hr className={style.hrLine} style={{ marginBottom: '2.2em' }} />
                <h3 className={`${style.testMarklabel} ${style.mainHeadings}`}>Test Instructions</h3>
                <p className={style.info}>Add instructions to appear before the test commences</p>
                {instruction?.map((instruction, index) => (
                  <div key={index + instruction} className={style.screenNum}>
                    <p style={{ fontWeight: 500, marginBottom: '5px' }}>Screen {index + 1}</p>
                    <div className={style.icon_text}>
                      <label className="custom-checkbox" aria-label="Has Timer">
                        <input
                          type="checkbox"
                          checked={Boolean(instruction.has_timer)}
                          onChange={(e) => handleTimerChange(e, 'has_timer', index)}
                        />
                        <span className="checkmark"></span>
                      </label>
                      {/* <label>Has Timer</label> */}

                      <p className={style.info}>Instruction Screen has a timer</p>
                    </div>

                    <div>
                      {Boolean(instruction.has_timer) && (
                        <div className={style.timer}>
                          <input
                            className={style.timer_input}
                            type="number"
                            name="minutes"
                            min="0"
                            max="100"
                            step="1"
                            autoComplete="off"
                            list="autocompleteoff"
                            value={instruction.minutes}
                            onChange={(e) => handleTimerChange(e, 'minutes', index)}
                          />
                          <label htmlFor="minutes">Minutes</label>

                          <input
                            className={style.timer_input}
                            type="number"
                            name="seconds"
                            min="0"
                            max="100"
                            step="1"
                            autoComplete="off"
                            list="autocompleteoff"
                            value={instruction.seconds}
                            onChange={(e) => handleTimerChange(e, 'seconds', index)}
                          />
                          <label htmlFor="seconds">Seconds</label>
                        </div>
                      )}

                      <p className={style.marketLogic}>Test Instructions </p>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '2rem',
                        }}
                      >
                        <div style={{ height: 'auto', flexGrow: '1' }}>
                          <QuillEditor
                            defaultValue={decodeBase64(instruction.instruction_text)}
                            onChange={(content) => handleInstructionTextChange(content, index)}
                            disabled={isView}
                          />
                        </div>
                        {!isView && (
                          <div>
                            {index !== 0 && (
                              <button type="button" className={style.penaltyDelete} onClick={() => removeScreen(index)}>
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M18.8504 9.14062L18.2004 19.2106C18.0904 20.7806 18.0004 22.0006 15.2104 22.0006H8.79039C6.00039 22.0006 5.91039 20.7806 5.80039 19.2106L5.15039 9.14062"
                                    stroke="#272727"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047"
                                    stroke="#272727"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
                                    stroke="#272727"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </button>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
                {!isView && (
                  <div onClick={() => addScreen()} className={style.threshold}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                        stroke="#00ABFB"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M7.5 12H16.5"
                        stroke="#00ABFB"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M12 16.5V7.5"
                        stroke="#00ABFB"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <h5 style={{ cursor: 'pointer' }}>Add Screen</h5>
                  </div>
                )}

                <div className={style.performBT}>
                  <button
                    className={` ${style.btOne} ${style.common} ${isView ? style.marginTop : ''}`}
                    onClick={() => {
                      navigate(`/test-papers-management`);
                    }}
                    style={{ pointerEvents: 'all' }}
                  >
                    Back
                  </button>
                  {!isView && (
                    <button className={` ${style.btTwo} ${style.common}`} onClick={() => handleSaveAndContinue()}>
                      Save & Continue
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}
          {testType == 2 && (
            <div className={style.templateDrop}>
              <hr className={style.hrLine} style={{ marginTop: '1em', marginBottom: '2.2em' }} />
              <div className={style.pageTwoContainer}>
                <h3 className={`${style.testMarklabel} ${style.mainHeadings}`}>Test Marking Details</h3>
                <p style={{ paddingTop: '10px', paddingBottom: '30px', margin: '0px' }} className={style.info}>
                  All questions will follow same marking logic unless new marking logics are created
                </p>
                <div className={style.bound}>
                  <div className={style.templateDrop}>
                    <div className={style.templateDrop_item}>
                      <div className={style.templateGroup}>
                        <span>Correct Answer Marks </span>
                        <b className={style.red_mendantory}>*</b>
                        <input
                          type="number"
                          name="question"
                          id="question"
                          className={style.score_drop_filter}
                          placeholder="Input +/- score"
                          value={correctAnswerMarks}
                          onChange={(e) => handleInputChange(e, setCorrectAnswerMarks)}
                          autoComplete="off"
                          onKeyDown={(e) => {
                            if (['e', 'E'].includes(e.key)) {
                              e.preventDefault();
                            }
                            if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                              e.preventDefault();
                            }
                          }}
                          onWheel={(e) => e.target.blur()}
                        />
                      </div>
                    </div>
                  </div>

                  <div className={style.templateDrop}>
                    <div className={style.templateDrop_item}>
                      <div className={style.templateGroup}>
                        <span>Incorrect Answer Marks </span>
                        <b className={style.red_mendantory}>*</b>
                        <input
                          type="number"
                          name="question"
                          id="question"
                          className={style.score_drop_filter}
                          placeholder="Input +/- score"
                          value={incorrectAnswerMarks}
                          onChange={(e) => handleInputChange(e, setIncorrectAnswerMarks)}
                          autoComplete="off"
                          onKeyDown={(e) => {
                            if (['e', 'E'].includes(e.key)) {
                              e.preventDefault();
                            }
                            if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                              e.preventDefault();
                            }
                          }}
                          onWheel={(e) => e.target.blur()}
                        />
                      </div>
                    </div>
                  </div>
                  <div className={style.templateDrop}>
                    <div className={style.templateDrop_item}>
                      <div className={style.templateGroup}>
                        <span>Unattempted Marks </span>
                        <input
                          type="number"
                          name="question"
                          id="question"
                          className={style.score_drop_filter}
                          placeholder="Input +/- score"
                          value={unattemptedPenalty}
                          onChange={(e) => setUnattemptedPenalty(e.target.value === '' ? null : Number(e.target.value))}
                          onBlur={(e) => setUnattemptedPenalty(e.target.value === '' ? null : Number(e.target.value))}
                          onKeyDown={(e) => {
                            if (['e', 'E'].includes(e.key)) {
                              e.preventDefault();
                            }
                            if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                              e.preventDefault();
                            }
                          }}
                          autoComplete="off"
                          list="autocompleteoff"
                          onWheel={(e) => e.target.blur()}
                        />
                      </div>
                    </div>
                  </div>
                  <div className={style.templateDrop}>
                    <div className={style.templateDrop_item}>
                      <div className={style.templateGroup}>
                        <span>Unattempted Penalty Start From </span>
                        <input
                          type="number"
                          name="question"
                          id="question"
                          className={style.score_drop_filter}
                          placeholder="Input +/- score"
                          value={unattempted_penalty_starts_from}
                          autoComplete="off"
                          onChange={(e) => {
                            const value = e.target.value;
                            setUnattempted_penalty_starts_from(value === '' ? null : Number(value));
                          }}
                          onKeyDown={(e) => {
                            if (['e', 'E'].includes(e.key)) {
                              e.preventDefault();
                            }
                            if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                              e.preventDefault();
                            }
                          }}
                          onWheel={(e) => e.target.blur()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <hr className={style.hrLine} style={{ marginBottom: '2.2em', marginTop: '1em' }} />
                <h3 className={`${style.testMarklabel} ${style.mainHeadings}`}>Test Instructions</h3>
                <p className={style.info}>Add instructions to appear before the test commences</p>
                {instruction?.map((instruction, index) => (
                  <div key={index + instruction} className={style.screenNum}>
                    <p style={{ fontWeight: 500, marginBottom: '5px' }}>Screen {index + 1}</p>
                    <div className={style.icon_text}>
                      <label className="custom-checkbox" aria-label="Has Timer">
                        <input
                          type="checkbox"
                          checked={Boolean(instruction.has_timer)}
                          onChange={(e) => handleTimerChange(e, 'has_timer', index)}
                        />
                        <span className="checkmark"></span>
                      </label>
                      {/* <label>Has Timer</label> */}

                      <p className={style.info}>Instruction Screen has a timer</p>
                    </div>
                    {Boolean(instruction.has_timer) && (
                      <div className={style.timer}>
                        <input
                          className={style.timer_input}
                          type="number"
                          name="minutes"
                          min="0"
                          max="100"
                          step="1"
                          autoComplete="off"
                          list="autocompleteoff"
                          value={instruction.minutes}
                          onChange={(e) => handleTimerChange(e, 'minutes', index)}
                        />
                        <label htmlFor="minutes">Minutes</label>

                        <input
                          className={style.timer_input}
                          type="number"
                          name="seconds"
                          min="0"
                          max="100"
                          step="1"
                          autoComplete="off"
                          list="autocompleteoff"
                          value={instruction.seconds}
                          onChange={(e) => handleTimerChange(e, 'seconds', index)}
                        />
                        <label htmlFor="seconds">Seconds</label>
                      </div>
                    )}
                    <p className={style.marketLogic} style={{ margin: '0px', marginBottom: '10px' }}>
                      Test Instructions{' '}
                    </p>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '2rem',
                      }}
                    >
                      <div style={{ height: 'auto', flexGrow: '1' }}>
                        <QuillEditor
                          defaultValue={decodeBase64(instruction.instruction_text)}
                          onChange={(content) => handleInstructionTextChange(content, index)}
                          disabled={isView}
                        />
                      </div>
                      {!isView && (
                        <div>
                          {index !== 0 && (
                            <button type="button" className={style.penaltyDelete} onClick={() => removeScreen(index)}>
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M18.8504 9.14062L18.2004 19.2106C18.0904 20.7806 18.0004 22.0006 15.2104 22.0006H8.79039C6.00039 22.0006 5.91039 20.7806 5.80039 19.2106L5.15039 9.14062"
                                  stroke="#272727"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047"
                                  stroke="#272727"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
                                  stroke="#272727"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
                {!isView && (
                  <div className={style.threshold}>
                    <div className={style.loftAddScreenWrap}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                          stroke="#00ABFB"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M7.5 12H16.5"
                          stroke="#00ABFB"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12 16.5V7.5"
                          stroke="#00ABFB"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <button className={style.LoftAddScreen} onClick={() => addScreen()}>
                        Add Screen
                      </button>
                    </div>
                  </div>
                )}
                <div className={style.icon_text} style={{ marginBottom: '20px' }}>
                  <label className="custom-checkbox" aria-label="Has Timer">
                    <input
                      type="checkbox"
                      checked={randomizeGroups}
                      onChange={() => setRandomizeGroups(!randomizeGroups)}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <p className={style.info}>Randomize Groups</p>
                </div>
                <div className={style.performBT}>
                  <button
                    className={` ${style.btOne} ${style.common} ${isView ? style.marginTop : ''}`}
                    onClick={() => {
                      navigate(`/test-papers-management`);
                    }}
                    style={{ pointerEvents: 'all' }}
                  >
                    Back
                  </button>
                  {!isView && (
                    <button className={` ${style.btTwo} ${style.common}`} onClick={() => handleSaveAndContinue()}>
                      Save & Continue
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  );
};

BasicSettings.propTypes = {
  MasterData: PropTypes.any,
  getData: PropTypes.any,
  isEdit: PropTypes.any,
  isView: PropTypes.any,
  onAdd: PropTypes.any,
  setSelectedType: PropTypes.func,
};

export default BasicSettings;
